const addLabelsToEnums = (options) => options.map((option) => ({ ...option, label: option.display_name }));

export default addLabelsToEnums;
